import { render } from "./StudyDetailView.vue?vue&type=template&id=6ed3d012&scoped=true"
import script from "./StudyDetailView.vue?vue&type=script&lang=js"
export * from "./StudyDetailView.vue?vue&type=script&lang=js"

import "./StudyDetailView.vue?vue&type=style&index=0&id=6ed3d012&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed3d012"]])

export default __exports__